import { fetcher } from '@/shared/api/fetcher';
import useSWR from 'swr';
import { useUser } from '@/shared/providers/user-provider/use-user';
import { useNotifications } from '@/shared/providers/notifications-provider/notifications-context';

export function useCategories() {
  const { user } = useUser();
  const { notifications } = useNotifications();
  const { data, error, isLoading } = useSWR('/categories', fetcher);

  const categories = Array.isArray(data) ? data : [];
  return {
    categories:
      notifications?.bonus?.isActive && notifications?.bonusInfo?.games
        ? [
            {
              id: 'bonus',
              imageUrl: '/images/icons/category-bonus.svg',
              gamesCount: notifications?.bonusInfo?.games?.length,
              rows: 1,
            },
            ...categories,
          ]
        : categories,
    isLoading: isLoading,
    isError: error,
  };
}
